import { resolveWallRewardClearSpeed } from "./wallRewardClearSpeed";
import type { WallDefinition } from "./wallDefinitions";
import { SPLIT_WALL_BALANCE_PROFILE } from "./wallBalanceProfiles";
import {
  DEFAULT_WALL_REWARD_CAP_LEVEL,
  type WallRewardCapLevel,
} from "./wallRewardCap";

export const SPLIT_WALL_CLEAR_TARGET_HOV =
  SPLIT_WALL_BALANCE_PROFILE.challenge.clearTargetHov;

export const SPLIT_WALL_DEFINITION: WallDefinition = {
  id: "split-wall",
  firstClearReward: SPLIT_WALL_BALANCE_PROFILE.firstClearReward,
};

export const SPLIT_WALL_H1G_REWARD_BASE_MULTIPLIER =
  SPLIT_WALL_BALANCE_PROFILE.reward.baseMultiplier;
export const SPLIT_WALL_H1G_REWARD_TARGET_CLEAR_MS =
  SPLIT_WALL_BALANCE_PROFILE.reward.targetClearMs;
export const SPLIT_WALL_H1G_REWARD_ACCELERATION =
  SPLIT_WALL_BALANCE_PROFILE.reward.acceleration;
export const SPLIT_WALL_H1G_REWARD_EXPONENT =
  SPLIT_WALL_BALANCE_PROFILE.reward.exponent;
export const SPLIT_WALL_H1G_REWARD_BASE_CAP_MULTIPLIER =
  SPLIT_WALL_BALANCE_PROFILE.reward.caps.base;
export const SPLIT_WALL_H1G_REWARD_RELAXED_CAP_MULTIPLIER =
  SPLIT_WALL_BALANCE_PROFILE.reward.caps.relaxed;

export function resolveSplitWallH1GRewardEffectiveMaxMultiplier(
  capLevel: WallRewardCapLevel = DEFAULT_WALL_REWARD_CAP_LEVEL,
): number {
  return capLevel === "relaxed"
    ? SPLIT_WALL_H1G_REWARD_RELAXED_CAP_MULTIPLIER
    : SPLIT_WALL_H1G_REWARD_BASE_CAP_MULTIPLIER;
}

export function resolveSplitWallH1GRewardMultiplier(
  bestClearMs: number | null,
  effectiveMaxMultiplier: number = resolveSplitWallH1GRewardEffectiveMaxMultiplier(),
): number {
  if (bestClearMs === null) return 1;
  if (!Number.isFinite(bestClearMs) || bestClearMs <= 0) {
    return SPLIT_WALL_H1G_REWARD_BASE_MULTIPLIER;
  }

  const ratio = resolveWallRewardClearSpeed(
    bestClearMs,
    SPLIT_WALL_H1G_REWARD_TARGET_CLEAR_MS,
    SPLIT_WALL_BALANCE_PROFILE.reward.softcapClearMs,
  );
  const acceleratedRatio = Math.max(0, ratio - 1);

  return Math.min(
    effectiveMaxMultiplier,
    Math.max(
      SPLIT_WALL_H1G_REWARD_BASE_MULTIPLIER,
      SPLIT_WALL_H1G_REWARD_BASE_MULTIPLIER +
        SPLIT_WALL_H1G_REWARD_ACCELERATION *
          Math.pow(acceleratedRatio, SPLIT_WALL_H1G_REWARD_EXPONENT),
    ),
  );
}
